export const PROPERTY_PATH_MAP = {
  floorPlan: {
    path: 'floorPlan',
    dataType: 'string',
  },
  bedsBaths: {
    path: 'bedsBaths',
    dataType: 'string',
  },
  numUnits: {
    path: 'numUnits',
    dataType: 'number',
  },
  currentBasicRent: {
    path: 'currentBasicRent',
    dataType: 'string',
  },
  currentNoteRent: {
    path: 'currentNoteRent',
    dataType: 'string',
  },
};

export const COMPLIANCE_STATES = {
  pass: 'pass',
  fail: 'fail',
  warning: 'warning',
};

export const DEFAULT_COLUMN_ORDER = {
  floorPlan: 0,
  bedsBaths: 1,
  unitType: 2,
  numUnits: 3,
  'Gross Rent Limit': 4,
  'Quoting Rent': 5,
  'Suggested Deposit': 6,
  'Financial Market Rent': 7,
  'Basic Rent': 8,
  'Note Rent': 9,
  'RD Utility Allowance': 38,
};

export const DEFAULT_SHOW_HIDE_STATE = [
  'floorPlan',
  'numUnits',
  'unitType',
  'currentHUDGrossRent',
  'totalHUDGrossRentIncome',
  'newHUDGrossRentProposedChange',
  'newHUDGrossRent',
  'newHUDGrossRentPotentialIncome',
  'currentnoteRent',
  'totalnoteRentIncome',
  'actualRentSpread',
  'newnoteRentProposedChange',
  'newnoteRent',
  'newnoteRentPotentialIncome',
  'currentbasicRent',
  'totalbasicRentIncome',
  'newbasicRentProposedChange',
  'newbasicRent',
  'newbasicRentPotentialIncome',
  'currentquotingRentAmount',
  'totalquotingRentAmountIncome',
  'newquotingRentAmountProposedChange',
  'newquotingRentAmount',
  'newquotingRentAmountPotentialIncome',
  'newnonOptionalCharge',
  'newnonOptionalChargeProposedChangeValue',
  'newhud236BasicRentProposedChangeValue',
  'newbasicRentProposedChangeValue',
  'newbaseMarketRentAmountProposedChangeValue',
  'newhud236MarketRentProposedChangeValue',
  'currentfinancialMarketRentAmount',
  'totalfinancialMarketRentAmountIncome',
  'newfinancialMarketRentAmountProposedChange',
  'newfinancialMarketRentAmountProposedChangeValue',
  'newfinancialMarketRentAmount',
  'newfinancialMarketRentAmountPotentialIncome',
  'currentestimatedDepositAmount',
  'totalestimatedDepositAmountIncome',
  'newestimatedDepositAmountProposedChange',
  'newestimatedDepositAmount',
  'newestimatedDepositAmountPotentialIncome',
  'currentutilityAllowance',
  'totalutilityAllowanceIncome',
  'newutilityAllowanceProposedChange',
  'newutilityAllowance',
  'newutilityAllowancePotentialIncome',
  'bedsBaths',
  'currentbaseMarketRentAmount',
  'totalbaseMarketRentAmountIncome',
  'newbaseMarketRentAmountProposedChange',
  'newbaseMarketRentAmount',
  'newbaseMarketRentAmountPotentialIncome',
  'currentRD Utility Allowance',
  'totalRD Utility AllowanceIncome',
  'newRD Utility AllowanceProposedChange',
  'newRD Utility Allowance',
  'newRD Utility AllowancePotentialIncome',
];

export const DEFAULT_SHOW_HIDE_STATE_RD = [
  'floorPlan',
  'bedsBaths',
  'unitType',
  'numUnits',
  'currentbasicRent',
  'totalbasicRentIncome',
  'newbasicRentProposedChange',
  'newbasicRent',
  'newbasicRentPotentialIncome',
  'currentnoteRent',
  'totalnoteRentIncome',
  'actualRentSpread',
  'newnoteRentProposedChange',
  'newnoteRent',
  'newnoteRentPotentialIncome',
  'currentRD Utility Allowance',
  'totalRD Utility AllowanceIncome',
  'newRD Utility AllowanceProposedChange',
  'newRD Utility Allowance',
  'newRD Utility AllowancePotentialIncome',
];

export const DEFAULT_SETTINGS_STATE = {
  condense: false,
  showAllContents: false,
};

export const columns = {
  baseMarketRentAmount: 'Base Market Rent',
  HUDGrossRent: 'HUD Gross Rent Limit',
  quotingRentAmount: 'Quoting Rent',
  estimatedDepositAmount: 'Suggested Deposit',
  financialMarketRentAmount: 'Financial Market Rent',
  nonOptionalCharge: 'Non-Optional Charges',
  hud236BasicRent: '236 Basic Rent',
  hud236MarketRent: '236 Market Rent',
  basicRent: 'Basic Rent',
  noteRent: 'Note Rent',
};

export const proposedChangeTypes = {
  dollar: '$',
  percent: '%',
};

export const FIELD_MAP = [
  ['newNoteRentProposedChangeValue', 'noteRent', 0],
  ['newBasicRentProposedChangeValue', 'basicRent', 0],
  ['newRDUtilityAllowanceProposedChangeValue', 'RDUtilityAllowance', 0],
  ['newHUDGrossRentProposedChangeValue', 'RDUtilityAllowance', 0],
  ['newNonOptionalCharge', 'nonOptionalCharge', 0],
  ['newHud236BasicRent', 'hud236BasicRent', 0],
  ['newHud236MarketRent', 'hud236MarketRent', 0],
  [
    'newTHDAUtilityAllowanceProposedChangeValue',
    'newTHDA Utility AllowanceProposedChangeValue',
    0,
  ],
  ['newBaseMarketRentAmountProposedChangeValue', 'baseMarketRentAmount', 0],
  ['newQuotingRentAmountProposedChangeValue', 'quotingRentAmount', 0],
  ['newEstimatedDepositAmountProposedChangeValue', 'estimatedDepositAmount', 0],
  ['newHudGrossRentProposedChange', 'HUDGrossRent', 0],
  ['newQuotingRentAmount', 'quotingRentAmount', 0],
  [
    'newQuotingRentAmountPotentialIncome',
    'quotingRentAmountPotentialIncome',
    0,
  ],
  ['newEstimatedDepositAmountProposedChange', 'estimatedDepositAmount', 0],
  ['newUtilityAllowanceProposedChange', 'utilityAllowance', 0],
  [
    'newFinancialMarketRentAmountProposedChangeValue',
    'financialMarketRentAmount',
    0,
  ],
  ['newHud236MarketRentProposedChangeValue', 'hud236MarketRent', 0],
  ['newNonOptionalChargeProposedChangeValue', 'nonOptionalCharge', 0],
  ['newHud236BasicRentProposedChangeValue', 'hud236BasicRent', 0],
  ['newFinancialMarketRentAmount', 'financialMarketRentAmount', 0],
];

export const SURPLUS_CASH_REQUIRED_EQUATION_PERCENTAGE = 0.2;

export const INTACCT_ABSOLUTE_FIELDS = [
  '0-0-7-currentBudget',
  '0-0-7-actual',
  '0-2-6-currentBudget',
  '0-2-6-actual',
  '2-0-1-currentBudget',
  '2-0-1-actual',
];
